import {createSelector} from 'reselect';

import {interpolateCustomAttributes} from '../../../helpers/customFieldHelpers';
import {AppParametricSelector, AppSelector} from '../../../helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {CustomFieldAttribute} from '../../../models/api/customFieldAttributeModel';
import {getLocalize} from '../../stateless/internationalizationSelectors';
import {getAccounts, getCustomFields} from '../dataSelectors';
import {getTimeFormat} from '../preferences/preferencesSelectors';
import {getFindTeammate} from '../teammates/lazyTeammatesSelectors';
import {getUserId} from '../teammates/teammatesSelectors';

export function makeGetInterpolatedCustomAttributes<P>(
  getCustomAttributes: AppParametricSelector<P, ReadonlyArray<CustomFieldAttribute> | undefined>,
) {
  return createSelector(
    [getCustomFields, getCustomAttributes, getLocalize, getTimeFormat],
    (customFields, customAttributes, localizer, timeFormat) =>
      interpolateCustomAttributes(customFields, customAttributes, localizer, timeFormat),
  );
}

export function makeGetTeammateCustomAttributes(
  getTeammateId: AppSelector<number>,
): AppSelector<ReadonlyArray<CustomFieldAttribute> | undefined> {
  return createSelector([getFindTeammate, getTeammateId], (findTeammate, teammateId) => {
    const teammate = findTeammate(teammateId, 'CustomAttributesSelector makeGetTeammateCustomAttributes');

    return teammate?.customFieldAttributes;
  });
}

export const getUserCustomAttributes = makeGetTeammateCustomAttributes(getUserId);

export function makeGetAccountCustomAttributesForCard<P>(
  getCard: AppParametricSelector<P, CardModel | undefined>,
): AppParametricSelector<P, ReadonlyArray<CustomFieldAttribute> | undefined> {
  return createSelector([getCard, getAccounts], (card, accounts) => {
    if (!card?.accountId) {
      return undefined;
    }

    return accounts[card.accountId]?.customFieldAttributes;
  });
}
